import { Badge, Dialog, IconButton, makeStyles, Slide } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux'
import { Button, Tooltip } from './common'
import { DialogOpener } from './common/dialog-opener'
import { TomImageProcess } from '../../tom/components/tom-image-process'
import { useNotProcessed } from '../../tom/hooks/useNotProcessed'
import { ImagesIcon } from 'lucide-react'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const useStyles = makeStyles(theme => ({
    btn: {
        fontSize: 15
    },
    tooltipClass: {
        marginRight: 10
    }
}))

export const TomNewPicturesIndicator = () => {
    const cls = useStyles()

    const { locale } = useSelector(state => state.main)

    const { data, isLoading, refetch } = useNotProcessed(
        'tomPicturesCount',
        1,
        true
    )

    const totalImages = data?.pages?.[0]?.data?.[0]?.total

    if (!isLoading && !totalImages) {
        return null
    }
    return (
        <DialogOpener
            dialog={(handleClose, { onOpen, onClose, open }) => (
                <Dialog
                    disableEscapeKeyDown
                    maxWidth="lg"
                    onEntered={onOpen}
                    onClose={onClose}
                    open={open}
                    // open
                    TransitionComponent={Transition}
                    fullScreen
                >
                    <TomImageProcess
                        onClose={() => {
                            onClose()
                            refetch()
                        }}
                    />
                </Dialog>
            )}
        >
            {handleOpen => {
                if (!isLoading) {
                    return (
                        <Tooltip
                            text={locale.tom.openTomBtnTitle}
                            hover
                            tooltipClass={cls.tooltipClass}
                        >
                            <IconButton
                                onClick={handleOpen}
                                style={{ marginRight: 10 }}
                            >
                                <Badge
                                    badgeContent={totalImages}
                                    color="error"
                                    overlap="rectangular"
                                >
                                    <ImagesIcon size={20} />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                    )
                }
            }}
        </DialogOpener>
    )
}
